import React from 'react';
import Consumption from './Consumption';
import ConsumptionPerEndpoint from './ConsumptionPerEndpoint';

const APIDashboards = () => (
  <div>
    <Consumption />
    <div style={{ marginTop: 16 }}>
      <ConsumptionPerEndpoint />
    </div>
  </div>
);

export default APIDashboards;
